import React from "react";
import BasicPhoneInput from "react-phone-number-input/basic-input";

export const PhoneInput = React.forwardRef((props, ref) => (
  <BasicPhoneInput ref={ref} value={props.value} onChange={props.onChange} {...props} />
));